var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConversationrate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.418 13.4937V32.9243C46.418 41.3747 41.3723 46.418 32.9243 46.418H13.4937C5.04563 46.418 0 41.3747 0 32.9243V13.4937C0 5.04331 5.04563 0 13.4937 0H32.9243C41.3723 0 46.418 5.04331 46.418 13.4937Z",
    fill: "url(#paint0_linear_3583_3204)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3672 18.7776H33.6302V20.6697H12.3672V18.7776Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8377 14.2527C17.8876 14.0825 18.6007 13.0934 18.4305 12.0435C18.2603 10.9936 17.2712 10.2804 16.2213 10.4506C15.1714 10.6208 14.4583 11.6099 14.6285 12.6598C14.7987 13.7097 15.7878 14.4229 16.8377 14.2527Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0003 14.2764C24.064 14.2764 24.9263 13.4141 24.9263 12.3504C24.9263 11.2866 24.064 10.4243 23.0003 10.4243C21.9365 10.4243 21.0742 11.2866 21.0742 12.3504C21.0742 13.4141 21.9365 14.2764 23.0003 14.2764Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.469 14.2764C30.5328 14.2764 31.3951 13.4141 31.3951 12.3504C31.3951 11.2866 30.5328 10.4243 29.469 10.4243C28.4053 10.4243 27.543 11.2866 27.543 12.3504C27.543 13.4141 28.4053 14.2764 29.469 14.2764Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9985 29.7273C20.8306 29.7273 19.0742 31.4837 19.0742 33.6515C19.0742 35.8194 20.8306 37.5758 22.9985 37.5758C25.1663 37.5758 26.9227 35.8194 26.9227 33.6515C26.9227 31.4837 25.1663 29.7273 22.9985 29.7273ZM22.9985 33.2273C23.7621 33.2273 24.3857 33.8509 24.3857 34.6146C24.3857 35.2297 23.9785 35.7473 23.4227 35.9297V36.1631C23.4227 36.3964 23.2318 36.5873 22.9985 36.5873C22.7651 36.5873 22.5742 36.3964 22.5742 36.1631V35.9297C22.0185 35.7473 21.6112 35.234 21.6112 34.6146C21.6112 34.3812 21.8021 34.1903 22.0354 34.1903C22.2688 34.1903 22.4597 34.3812 22.4597 34.6146C22.4597 34.9115 22.7015 35.1534 22.9985 35.1534C23.2954 35.1534 23.5372 34.9115 23.5372 34.6146C23.5372 34.3176 23.2954 34.0758 22.9985 34.0758C22.2348 34.0758 21.6112 33.4521 21.6112 32.6885C21.6112 32.0734 22.0185 31.5558 22.5742 31.3734V31.14C22.5742 30.9067 22.7651 30.7158 22.9985 30.7158C23.2318 30.7158 23.4227 30.9067 23.4227 31.14V31.3734C23.9785 31.5558 24.3857 32.0691 24.3857 32.6885C24.3857 32.9218 24.1948 33.1127 23.9615 33.1127C23.7282 33.1127 23.5372 32.9218 23.5372 32.6885C23.5372 32.3915 23.2954 32.1497 22.9985 32.1497C22.7015 32.1497 22.4597 32.3915 22.4597 32.6885C22.4597 32.9855 22.7015 33.2273 22.9985 33.2273Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0666 28.3314V29.2902C21.6562 29.0272 22.3096 28.8787 22.9969 28.8787C23.6841 28.8787 24.3375 29.0272 24.9272 29.2902V28.3314L31.3375 21.5181H14.6562L21.0666 28.3314Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3495 17.0934C19.3495 16.0752 18.8107 15.1885 18.0046 14.6921C17.5761 14.9637 17.0713 15.1206 16.5282 15.1206C15.9852 15.1206 15.4804 14.9637 15.0519 14.6921C14.2458 15.1885 13.707 16.0752 13.707 17.0934V17.9249H19.3495V17.0934Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8182 17.0934C25.8182 16.0752 25.2794 15.1885 24.4734 14.6921C24.0449 14.9637 23.54 15.1206 22.997 15.1206C22.454 15.1206 21.9491 14.9637 21.5206 14.6921C20.7146 15.1885 20.1758 16.0794 20.1758 17.0934V17.9249H25.8182V17.0934Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2909 17.0934C32.2909 16.0752 31.7521 15.1885 30.946 14.6921C30.5175 14.9637 30.0127 15.1206 29.4697 15.1206C28.9266 15.1206 28.4218 14.9637 27.9933 14.6921C27.1872 15.1885 26.6484 16.0752 26.6484 17.0934V17.9249H32.2909V17.0934Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3583_3204",
    x1: 54,
    y1: -13.5,
    x2: 6,
    y2: 45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00937462,
    stopColor: "#FFC451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB2727"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConversationrate);
export default __webpack_public_path__ + "static/media/conversationrate.0d71e10270ebbd4f9cd179139326737c.svg";
export { ForwardRef as ReactComponent };